/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Elite_IntelligenceInputs */

const en_pricing_feature_elite_intelligence = /** @type {(inputs: Pricing_Feature_Elite_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elite Neural Intelligence`)
};

const es_pricing_feature_elite_intelligence = /** @type {(inputs: Pricing_Feature_Elite_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inteligencia Neuronal de Élite`)
};

const fr_pricing_feature_elite_intelligence = /** @type {(inputs: Pricing_Feature_Elite_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intelligence neuronale d'élite`)
};

const de_pricing_feature_elite_intelligence = /** @type {(inputs: Pricing_Feature_Elite_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elite Neuronale Intelligenz`)
};

const id_pricing_feature_elite_intelligence = /** @type {(inputs: Pricing_Feature_Elite_IntelligenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kecerdasan Neural Elit`)
};

/** @type {(inputs: Pricing_Feature_Elite_IntelligenceInputs) => LocalizedString} */
const ja_pricing_feature_elite_intelligence = en_pricing_feature_elite_intelligence;

/** @type {(inputs: Pricing_Feature_Elite_IntelligenceInputs) => LocalizedString} */
const zh_pricing_feature_elite_intelligence = en_pricing_feature_elite_intelligence;

/** @type {(inputs: Pricing_Feature_Elite_IntelligenceInputs) => LocalizedString} */
const ar_pricing_feature_elite_intelligence = en_pricing_feature_elite_intelligence;

/** @type {(inputs: Pricing_Feature_Elite_IntelligenceInputs) => LocalizedString} */
const it_pricing_feature_elite_intelligence = en_pricing_feature_elite_intelligence;

/** @type {(inputs: Pricing_Feature_Elite_IntelligenceInputs) => LocalizedString} */
const ru_pricing_feature_elite_intelligence = en_pricing_feature_elite_intelligence;

/** @type {(inputs: Pricing_Feature_Elite_IntelligenceInputs) => LocalizedString} */
const pt_pricing_feature_elite_intelligence = en_pricing_feature_elite_intelligence;

/** @type {(inputs: Pricing_Feature_Elite_IntelligenceInputs) => LocalizedString} */
const ko_pricing_feature_elite_intelligence = en_pricing_feature_elite_intelligence;

/**
* | output |
* | --- |
* | "Elite Neural Intelligence" |
*
* @param {Pricing_Feature_Elite_IntelligenceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_elite_intelligence = /** @type {((inputs?: Pricing_Feature_Elite_IntelligenceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Elite_IntelligenceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_feature_elite_intelligence(inputs)
	if (locale === "es") return es_pricing_feature_elite_intelligence(inputs)
	if (locale === "fr") return fr_pricing_feature_elite_intelligence(inputs)
	if (locale === "de") return de_pricing_feature_elite_intelligence(inputs)
	if (locale === "ja") return ja_pricing_feature_elite_intelligence(inputs)
	if (locale === "zh") return zh_pricing_feature_elite_intelligence(inputs)
	if (locale === "ar") return ar_pricing_feature_elite_intelligence(inputs)
	if (locale === "id") return id_pricing_feature_elite_intelligence(inputs)
	if (locale === "it") return it_pricing_feature_elite_intelligence(inputs)
	if (locale === "ru") return ru_pricing_feature_elite_intelligence(inputs)
	if (locale === "pt") return pt_pricing_feature_elite_intelligence(inputs)
	return ko_pricing_feature_elite_intelligence(inputs)
});